var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BuyoutList',{attrs:{"goldsmith":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }